import { render, staticRenderFns } from "./EditableTextField.vue?vue&type=template&id=4bd820d0&scoped=true"
import script from "./EditableTextField.vue?vue&type=script&lang=js"
export * from "./EditableTextField.vue?vue&type=script&lang=js"
import style0 from "./EditableTextField.vue?vue&type=style&index=0&id=4bd820d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd820d0",
  null
  
)

export default component.exports